// app/javascript/utils/date_input_ptbr.js
//
// Exibe todos os input[type="date"] no formato dd/mm/aaaa (pt-BR) sem
// depender do locale do browser/SO.
//
// Estratégia:
//   - Campo visível:  type="text" com máscara dd/mm/aaaa (sem troca de tipo)
//   - Campo oculto:   type="date" com o `name` original → enviado ao servidor
//   - Ícone de calendário → abre o picker nativo via .showPicker()
//   - Ao escolher no picker → texto atualiza em dd/mm/aaaa automaticamente

const CALENDAR_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z" clip-rule="evenodd"/>
</svg>`;

function toDisplay(iso) {
  if (!iso || iso.length !== 10) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return "";
  return `${d}/${m}/${y}`;
}

function toISO(br) {
  if (!br || br.length !== 10) return "";
  const [d, m, y] = br.split("/");
  if (!d || !m || !y || y.length !== 4) return "";
  return `${y}-${m}-${d}`;
}

function applyMask(value) {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  if (digits.length >= 5) return `${digits.slice(0,2)}/${digits.slice(2,4)}/${digits.slice(4)}`;
  if (digits.length >= 3) return `${digits.slice(0,2)}/${digits.slice(2)}`;
  return digits;
}

function wrapDateInput(original) {
  if (original.dataset.ptbrWrapped) return;
  original.dataset.ptbrWrapped = "1";

  const isoValue = original.value || "";

  // ── Wrapper relativo para posicionar o ícone ──────────────────────────
  const wrapper = document.createElement("div");
  wrapper.className = "relative";
  original.parentNode.insertBefore(wrapper, original);
  wrapper.appendChild(original);

  // ── Campo de texto visível (sem name — não é enviado) ─────────────────
  const text = document.createElement("input");
  text.type         = "text";
  text.placeholder  = "dd/mm/aaaa";
  text.maxLength    = 10;
  text.autocomplete = "off";
  text.className    = original.className + " pr-9";
  text.value        = toDisplay(isoValue);
  wrapper.insertBefore(text, original);

  // ── Ícone de calendário ───────────────────────────────────────────────
  const btn = document.createElement("button");
  btn.type      = "button";
  btn.className = "absolute inset-y-0 right-2 flex items-center text-gray-400 hover:text-gray-600 focus:outline-none";
  btn.innerHTML = CALENDAR_SVG;
  wrapper.appendChild(btn);

  // ── Campo date oculto — mantém o name e será enviado ao servidor ──────
  original.className = "";
  original.style.cssText = "position:absolute;opacity:0;width:1px;height:1px;pointer-events:none;";
  // name já está no original

  // ── Eventos ───────────────────────────────────────────────────────────

  // Máscara automática ao digitar
  text.addEventListener("input", () => {
    const pos    = text.selectionStart;
    const before = text.value.length;
    text.value   = applyMask(text.value);
    const diff   = text.value.length - before;
    text.setSelectionRange(pos + diff, pos + diff);
  });

  // Ao sair do campo de texto: sincroniza o hidden
  text.addEventListener("blur", () => {
    const iso = toISO(text.value);
    original.value = iso;
    if (!iso && text.value.replace(/\D/g, "").length > 0) {
      text.value     = "";
      original.value = "";
    }
  });

  // Ícone abre o picker nativo
  btn.addEventListener("click", () => {
    try {
      original.showPicker();
    } catch {
      original.click();
    }
  });

  // Quando o picker escolhe uma data: atualiza o texto
  original.addEventListener("change", () => {
    text.value = toDisplay(original.value);
  });
}

function initDateInputsBR(root) {
  (root || document)
    .querySelectorAll('input[type="date"]:not([data-ptbr-wrapped])')
    .forEach(wrapDateInput);
}

document.addEventListener("DOMContentLoaded", () => initDateInputsBR());
document.addEventListener("turbo:load",       () => initDateInputsBR());
document.addEventListener("turbo:render",     () => initDateInputsBR());
